import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { mutatorAction } from 'satcheljs';

// function which determines if anything is a given object and not of array type or null
const isNonArrayObject = (item: any) => item && typeof item === 'object' && !Array.isArray(item);

// function which helps in deep merging two objects
// for keys with array objects, replace the target value with the source instead of merging the two arrays
// this function does not take care of the situation where circular dependencies exist in the object and we assume in the
// situation where it is being used such a situation never arises ( graph archival problem )
const mergeDeep = (target, source) => {
    const output = target;
    if (isNonArrayObject(target) && isNonArrayObject(source)) {
        Object.keys(source).forEach(key => {
            output[key] =
                isNonArrayObject(source[key]) && key in target
                    ? mergeDeep(target[key], source[key])
                    : source[key];
        });
    }
    return output;
};

/**
 * Util which helps in changing the local user configuration with the given list of changes
 * This performs a deep merge
 * @param changes The properties which need to be modified for the
 */
const updateUserOptions = mutatorAction(
    'updateUserOptions',
    (changes: Partial<OwaUserConfiguration>) => {
        changes && mergeDeep(getUserConfiguration(), changes);
    }
);

export default updateUserOptions;
